import { Lock } from '../async/Lock';

import AsyncLRUCache from './AsyncLRUCache';

export class ConcurrentLRUCache<K, V> extends AsyncLRUCache<K, V> {
  private readonly lock = new Lock();

  public async getEntry(key: K): Promise<V> {
    await this.lock.acquire();
    let entry: V;

    try {
      entry = await super.getEntry(key);
    } finally {
      this.lock.release();
    }

    return entry;
  }
}
